import React, { useEffect, useState } from 'react';
import FindTransport from './components/find-transport';
import RouteDestinationItem from './components/origin-destination-list-item';
import useDetectIsMobile from '../../hook/use-detect-is-mobile';
import AdjustIcon from '../../assets/adjust-icon';
import Modal from '../../components/modal';
import OriginToDestination from './components/origin-to-destination';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API, ROUTES } from '../../helpers/constants';
import { toHoursAndMinutes } from '../../helpers/time';
import useGet from '../../hook/use-get';
import Error from '../../components/error';
import FilterTransport from './components/filter-transport';
import BannerContent from './components/banner';
import EmptyList from "../../components/empty-list";
import Pagination from "../../components/pagination";

const initFilterState = {
  service_id: [],
  company_id: [],
  class_name: [],
  price_id: "",
  operational_id: []
};

const TransSchedule = () => {
  const { isMobile } = useDetectIsMobile();
  const navigate = useNavigate();
  const [isShowFilter, setIsShowFilter] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [filterOptions, setFilterOptions] = useState(initFilterState);

  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = Number(searchParams.get('halaman')) || 1;
  const [maxPageLimit, setMaxPageLimit] = useState(8);
  const [minPageLimit, setMinPageLimit] = useState(0);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const origin = searchParams.get('asal');
  const destination = searchParams.get('tujuan');

  const {
    data: transportSchedules,
    isFetching: isFetchingSchedule,
    isError,
    refetch,
    dataPages
  } = useGet({
    queryKey: 'transportSchedules',
    api: `${API.transportSchedule}/from/${origin}/to/${destination}`,
    method: 'post',
    data: filterOptions,
    config: {
      params: {
        page: currentPage
      }
    }
  });

  const onSearchHandler = ({ origin, destination }) => {
    setIsSearch(false);
    setFilterOptions(initFilterState);
    setSearchParams({
      asal: origin,
      tujuan: destination
    });
  };

  const onSetFilterOptions = (opts) => {
    setFilterOptions(opts)
  }

  useEffect(() => {
    if (origin && destination) refetch();
  }, [origin, destination, filterOptions, currentPage]);

  const onClickDestinationItem = (operationalId, ruteId) => {
    navigate(`${ROUTES.trans_schedule}/${operationalId}/rute/${ruteId}`);
  };

  const onChangeCurrentPageHandler = (page) => {
    setCurrentPage(page);
    setSearchParams({
      ...Object.fromEntries([...searchParams]),
      halaman: page
    });
  };

  const renderTransportItem = () => {
    if (isFetchingSchedule) {
      return (
        <>
          {Array(6)
            .fill(0)
            .map(() => (
              <div className="w-full h-36 m-auto rounded-lg bg-gray-300 animate-pulse" />
            ))}
        </>
      );
    }

    if (isError) {
      return <Error refetch={refetch} />;
    }

    if (!transportSchedules?.length) {
      return <EmptyList />
    }

    return (
      <>
        {transportSchedules?.map((item) => (
          <RouteDestinationItem
            company={{
              name: item?.name,
              logo: item?.['company_logo_url']
            }}
            origin={{
              name: item?.['initial_name'],
              city: item?.['initial_city']
            }}
            destination={{
              name: item?.['destination_name'],
              city: item?.['destination_city']
            }}
            departureTime={`${item?.['operational_start']} - ${item?.['operational_end']}`}
            travelTime={toHoursAndMinutes(item?.['estimated_travel_time'])}
            busType={item?.['mnemonic']}
            busClass={item?.['class_name']}
            cost={item?.tariff}
            facilities={item?.facility}
            onClick={() => onClickDestinationItem(item?.['operational_id'], item?.rute)}
            seat={item?.seat}
            seatLayout={item?.['seat_layout']}
            rute={item?.rute}
          />
        ))}
        <Pagination
          onChangeMaxPageLimit={setMaxPageLimit}
          onChangeMinPageLimit={setMinPageLimit}
          maxPageLimit={maxPageLimit}
          minPageLimit={minPageLimit}
          pageNumberLimit={8}
          onChangeCurrentPage={onChangeCurrentPageHandler}
          currentPage={currentPage}
          totalPage={dataPages?.pageCount}
        />
      </>
    );
  };

  return (
    <div className="bg-white md:bg-neutral-50 pb-10 relative">
      <div className="md:w-[80%] m-auto space-y-0 md:space-y-3">
        <BannerContent />
        <div className="hidden md:block">
          {isSearch ? (
            <FindTransport
              isHideTitle
              onSubmit={onSearchHandler}
              defaultOrigin={origin}
              defaultDestination={destination}
            />
          ) : (
            <OriginToDestination
              isShowButton
              onClick={() => setIsSearch(true)}
              origin={origin}
              destination={destination}
            />
          )}
        </div>
        <div className="md:hidden block shadow sticky z-30 top-20 left-0">
          <OriginToDestination origin={origin} destination={destination} />
        </div>
        {isSearch && (
          <div className="pt-4 px-4 md:hidden">
            <FindTransport
              isHideBorder
              onSubmit={onSearchHandler}
              defaultOrigin={origin}
              defaultDestination={destination}
            />
          </div>
        )}
        <div className="md:hidden flex p-3 px-8 justify-between items-center border-b mb-4">
          <button
            onClick={() => setIsShowFilter(true)}
            type="button"
            className={`flex gap-2 justify-center items-center border border-gray-300 rounded-lg text-sm px-3 py-2`}
          >
            Filter <AdjustIcon />
          </button>
          <button
            onClick={() => setIsSearch(!isSearch)}
            type="button"
            className={`border border-[#0AB7F1] text-[#0AB7F1] rounded-lg text-sm px-3 py-2`}
          >
            Ubah Pencarian
          </button>
        </div>
        <div className="flex gap-4">
          <div className="w-[30%] hidden md:block">
            <FilterTransport
              onSetFilterOptions={onSetFilterOptions}
              filterOptions={filterOptions}
              disabled={isFetchingSchedule}
            />
          </div>
          <div className="md:w-[70%] w-[80%] space-y-6 mx-auto">
            {renderTransportItem()}
          </div>
        </div>
        <FilterTransport
          onBack={() => setIsShowFilter(false)}
          onSetFilterOptions={onSetFilterOptions}
          filterOptions={filterOptions}
          disabled={isFetchingSchedule}
          isModal={true}
          isOpen={isMobile && isShowFilter}
        />
      </div>
    </div>
  );
};

export default TransSchedule;
